<!-- Command Settings -->
<div>

  <div class="form-row">
    <!-- CATEGORY -->
    <div class="col">
      <div class="form-group">
        <label for="category" translate>Generic Gateways</label>
        <scitis-required-field-indicator></scitis-required-field-indicator>
        @if (isLoadingGatways) {
          <span class="fa-solid fa-gear fa-spin"></span>
        }
        <ng-select (change)="onGatewayChange($event)"
          [(ngModel)]="selectedGateway"
          (clear)="onClear()"
          [items]="genericGateways"
          bindLabel="name"
          id="gateway">
        </ng-select>
      </div>
    </div>
  </div>

  <div
    class="d-flex align-items-center justify-content-center mb-3 mt-0 alert alert-info text-center">
    <em class="fa-solid fa-circle-info mr-2"></em>
    <span translate>This feature only works for generic gateways. If there are no generic gateways this widget cannot be used.</span>
  </div>

  @if (!userDefinedWidget.userDefinedChartDetails.usingStaticData) {
    <div>
      <scitis-widget-configuration-signals-selector
        (signalSelectionChanged)="onSignalSelected($event)"
        [items]="filteredMachineSignals"
        [multiSelection]="true"
        [selectedSignalsIds]="selectedSignalIds"
        [showColor]="false"
        [validate]="false"
        [isCommandWidget]="true">
      </scitis-widget-configuration-signals-selector>
      <span class="form-label" translate>Selected signals</span>
      @if (!userDefinedWidget.userDefinedChartDetails.signals || userDefinedWidget.userDefinedChartDetails.signals.length===0) {
        <div
          class="alert alert-info text-center">
          <span translate>Currently no signals have been added, please add one from above.</span>
        </div>
      }
      <ul [(dragulaModel)]="userDefinedWidget.userDefinedChartDetails.signals" [dragula]="dragAndDropItems"
        class="list-group">
        @for (signal of userDefinedWidget.userDefinedChartDetails.signals; track signal) {
          <li class="list-group-item draggable">
            <div class="row">
              <div class="col align-items-center d-flex">
                <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
                <span [innerText]="signal.label | translate | truncate" class="truncate"></span>
                <span [innerHTML]="getSignalUnit(signal)" class="ml-1 text-muted"></span>
                <span class="command-badge badge badge-pill badge-info" [innerText]="getSignalWritableStatus(signal)" translate>writable</span>
              </div>
              <div class="col-auto align-items-center d-flex">
                <button (click)="onRemoveSignal(signal)" [title]="'Remove signal'|translate"
                  class="btn btn-xs btn-outline-danger ml-2">
                  <span class="fa-solid fa-trash"></span>
                </button>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>
